<script setup lang="ts">
import { computed, ref } from 'vue';

interface Props {
  src: string;
  alt: string;
}

const props = withDefaults(defineProps<Props>(), {});

const invalidImageSrc = ref(false);

const onImageError = () => {
  invalidImageSrc.value = true;
};

const getSrc = computed(() => props.src || '');
</script>

<template>
  <img v-if="!invalidImageSrc" :src="getSrc" :alt v-bind="$attrs" @error="onImageError" />
</template>
